import { FormFields } from 'app/model/form-fields';
import { RescheduleTechnicianFormModel } from 'app/page/orders/reschedule-technician/reschedule-technician-form-model';

const RESCHEDULE_TECHNICIAN_FORM_FIELDS: FormFields<RescheduleTechnicianFormModel> = {
    installationDate: 'installationDate',
    installationHour: 'installationHour',
    contactName: 'contactName',
    phoneNumber: 'phoneNumber',
    technicianCanContactMe: 'technicianCanContactMe',
    rightOfWithdrawalIsAgreed: 'rightOfWithdrawalIsAgreed',
};

export { RESCHEDULE_TECHNICIAN_FORM_FIELDS };
